import React, { useState } from 'react';
import { Phone, MessageCircle, Menu, X, ChevronDown, Star, Scissors } from 'lucide-react';
import _MG_0086 from "../assets/all-images/barber/_MG_0086.jpg";
import _MG_0085 from "../assets/all-images/barber/_MG_0085.jpg";
import _MG_0088 from "../assets/all-images/barber/_MG_0088.jpg";
import _MG_0101 from "../assets/all-images/barber/_MG_0101.jpg";
import beard from "../assets/all-images/barber/beard.jpg";


const Barbershop = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const services = [
    {
      title: "The Classic Cut",
      image: _MG_0086,
      items: ["Consultation & Style Advice", "Precision Scissor & Clipper Cut", "Hot Towel Finish", "Styling Product Application"]
    },
    {
      title: "Beard Sculpting",
      image: _MG_0085,
      items: ["Beard Trimming & Shaping", "Straight Razor Line-up", "Hot Towel Treatment", "Beard Oil Massage"]
    },
    {
      title: "The Royal Treatment",
      image: _MG_0088,
      items: ["Premium Haircut & Wash", "Full Beard Grooming", "Mini Facial", "Shoulder Massage"]
    },
    {
      title: "Skin Care & Facials",
      image: _MG_0101,
      items: ["Black Mask Peel", "Deep Pore Cleansing", "Exfoliating Scrub", "Moisturizing Finish"]
    },
    {
      title: "Junior Gents",
      image: beard,
      items: ["Kid-Friendly Haircut (Under 12)", "Design Etching", "Complimentary Snack", "Light Styling"]
    },
    {
      title: "Color & Dye",
      image: "https://images.unsplash.com/photo-1520338661084-680395057c93?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      items: ["Grey Blending", "Full Head Color", "Beard Dye", "Highlighting"]
    }
  ];

  const testimonials = [
    { name: "John Doe", text: "The best fade in the city, hands down. The attention to detail is unmatched.", rating: 5 },
    { name: "Michael K.", text: "Finally found a barber who understands how to shape my beard properly.", rating: 5 },
    { name: "Samuel O.", text: "Great vibes, professional staff, and they are always on time.", rating: 5 }
  ];

  const faqs = [
    { q: "Do I need to book an appointment?", a: "While walk-ins are welcome, we highly recommend booking an appointment to avoid waiting times." },
    { q: "What are your operating hours?", a: "We are open Monday through Saturday from 8:00 AM to 8:00 PM, and Sundays from 10:00 AM to 5:00 PM." },
    { q: "Do you cut children's hair?", a: "Absolutely! We offer special 'Junior Gents' cuts for children under 12." },
    { q: "What payment methods do you accept?", a: "We accept Cash, M-Pesa, and major Credit/Debit cards." }
  ];

  return (
    <div className="app-container">
      <style>{`
        :root {
          --primary: #000D6B;
          --secondary: #ffffff;
          --accent-1: #F9A826;
          --accent-2: #F28500;
          --whatsapp: #F9A826;
          --call-btn: #000D6B;
          --text-dark: #333333;
          --text-light: #f4f4f4;
          --bg-light: #f9fafb;
        }

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
          background-color: var(--bg-light);
          color: var(--text-dark);
          line-height: 1.6;
        }

        .navbar {
          background-color: var(--primary);
          color: var(--secondary);
          padding: 1rem 2rem;
          position: sticky;
          top: 0;
          z-index: 1000;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          font-size: 1.5rem;
          font-weight: bold;
          text-transform: uppercase;
          letter-spacing: 2px;
          display: flex;
          align-items: center;
          gap: 8px;
          color: var(--accent-1);
        }

        .nav-links {
          display: flex;
          gap: 2rem;
        }

        .nav-links a {
          color: var(--secondary);
          text-decoration: none;
          font-weight: 500;
          transition: color 0.3s;
        }

        .nav-links a:hover {
          color: var(--accent-1);
        }

        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          color: var(--secondary);
          cursor: pointer;
        }

        .hero {
          height: 100vh;
          background-image: linear-gradient(rgba(0, 13, 107, 0.7), rgba(0, 13, 107, 0.7)),
            url('https://images.unsplash.com/photo-1585747860715-2ba37e788b70?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80');
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          color: var(--secondary);
          padding: 0 1rem;
        }

        .hero-title {
          font-size: 4rem;
          font-weight: 800;
          text-transform: uppercase;
          margin-bottom: 1rem;
          line-height: 1.1;
        }

        .hero-title span {
          color: var(--accent-1);
        }

        .hero-subtitle {
          font-size: 1.25rem;
          margin-bottom: 2.5rem;
          max-width: 600px;
          color: #e0e0e0;
        }

        .cta-group {
          display: flex;
          gap: 1rem;
        }

        .btn {
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: bold;
          text-decoration: none;
          transition: transform 0.2s, opacity 0.2s;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          border: none;
          cursor: pointer;
        }

        .btn:hover {
          transform: translateY(-2px);
          opacity: 0.9;
        }

        .btn-primary {
          background-color: var(--accent-1);
          color: var(--primary);
        }

        .btn-outline {
          border: 2px solid var(--secondary);
          color: var(--secondary);
          background: transparent;
        }

        .section {
          padding: 5rem 2rem;
        }

        .section-header {
          text-align: center;
          margin-bottom: 4rem;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        .section-title {
          color: var(--primary);
          font-size: 2.5rem;
          font-weight: 700;
          text-transform: uppercase;
          margin-bottom: 1rem;
          position: relative;
          display: inline-block;
        }

        .section-title::after {
          content: '';
          display: block;
          width: 80px;
          height: 4px;
          background-color: var(--accent-1);
          margin: 0.5rem auto 0;
          border-radius: 2px;
        }

        .section-desc {
          color: #666;
          font-size: 1.1rem;
        }

        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2.5rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        .service-card {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: transform 0.3s ease;
          display: flex;
          flex-direction: column;
          border-top: 5px solid var(--accent-1);
        }

        .service-card:hover {
          transform: translateY(-10px);
        }

        .card-image {
          width: 100%;
          height: 220px;
          object-fit: cover;
        }

        .card-content {
          padding: 2rem;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
        }

        .card-title {
          color: var(--primary);
          font-size: 1.5rem;
          font-weight: bold;
          margin-bottom: 1rem;
          text-align: center;
        }

        .service-list {
          list-style-type: decimal;
          list-style-position: inside;
          margin-bottom: 2rem;
          color: #555;
          flex-grow: 1;
        }

        .service-list li {
          margin-bottom: 0.5rem;
          padding-left: 0.5rem;
        }

        .card-actions {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-top: auto;
        }

        .btn-call {
          background-color: var(--call-btn);
          color: white;
          width: 100%;
          border-radius: 8px;
          padding: 12px;
          text-align: center;
        }

        .btn-whatsapp {
          background-color: var(--whatsapp);
          color: white;
          width: 100%;
          border-radius: 8px;
          padding: 12px;
          text-align: center;
        }

        .info-section {
          background: white;
          padding: 5rem 2rem;
          border-top: 1px solid #e2e8f0;
        }

        .split-layout {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        .faq-side, .testimonial-side {
          display: flex;
          flex-direction: column;
        }

        .subsection-header {
          text-align: left;
          margin-bottom: 2rem;
        }

        .subsection-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: var(--primary);
          margin-bottom: 0.5rem;
        }

        .subsection-desc {
          font-size: 1rem;
          color: #64748b;
        }

        .faq-item {
          margin-bottom: 1.5rem;
          border-bottom: 1px solid #f1f5f9;
          padding-bottom: 1.5rem;
        }

        .faq-question {
          width: 100%;
          padding: 0;
          text-align: left;
          background: none;
          border: none;
          font-size: 1rem;
          font-weight: 700;
          color: var(--primary);
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          margin-bottom: 0.8rem;
        }

        .faq-answer {
          color: #64748b;
          line-height: 1.6;
          font-size: 0.95rem;
        }

        .testimonial-card {
          background: #f8fafc;
          padding: 2rem;
          border-radius: 16px;
          margin-bottom: 1.5rem;
          border: 1px solid #eef2f6;
        }

        .testimonial-text {
          font-style: italic;
          color: #475569;
          margin-bottom: 1rem;
          line-height: 1.6;
          font-size: 0.95rem;
        }

        .testimonial-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .client-name {
          font-weight: 700;
          font-size: 0.9rem;
          color: var(--primary);
        }

        .rating {
          display: flex;
          gap: 2px;
        }

        .mobile-menu {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh;
          background-color: var(--primary);
          z-index: 2000;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 2rem;
        }

        .mobile-link {
          color: white;
          font-size: 1.5rem;
          text-decoration: none;
          font-weight: bold;
        }

        .close-menu {
          position: absolute;
          top: 1.5rem;
          right: 2rem;
          background: none;
          border: none;
          color: white;
          cursor: pointer;
        }

        footer {
          background-color: var(--primary);
          color: rgba(255,255,255,0.6);
          padding: 2rem;
          text-align: center;
          font-size: 0.9rem;
        }

        @media (max-width: 1024px) {
          .services-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .split-layout {
            gap: 3rem;
          }
          .hero-title { font-size: 3rem; }
        }

        @media (max-width: 768px) {
          .nav-links { display: none; }
          .mobile-menu-btn { display: block; }
          .services-grid {
            grid-template-columns: 1fr;
          }
          .split-layout {
            grid-template-columns: 1fr;
            gap: 3rem;
          }
          .hero-title { font-size: 2.5rem; }
          .cta-group {
            flex-direction: column;
            width: 100%;
          }
          .btn { width: 100%; }
        }
      `}</style>


      {isMenuOpen && (
        <div className="mobile-menu">
          <button className="close-menu" onClick={() => setIsMenuOpen(false)}>
            <X size={32} />
          </button>
          <a href="#home" className="mobile-link" onClick={() => setIsMenuOpen(false)}>Home</a>
          <a href="#services" className="mobile-link" onClick={() => setIsMenuOpen(false)}>Services</a>
          <a href="#testimonials" className="mobile-link" onClick={() => setIsMenuOpen(false)}>Testimonials</a>
          <a href="#faq" className="mobile-link" onClick={() => setIsMenuOpen(false)}>FAQ</a>
        </div>
      )}

      <header id="home" className="hero">
        <h1 className="hero-title">
          Sharp Cuts<br />
          <span>Classic Style</span>
        </h1>
        <p className="hero-subtitle">
          Experience the art of grooming in an atmosphere of relaxation and refinement.
        </p>
        <div className="cta-group">
          <a href="#services" className="btn btn-primary">
            View Services
          </a>
          <a href="tel:+254720333127" className="btn btn-outline">
            <Phone size={18} /> Call Us
          </a>
        </div>
      </header>

      <section id="services" className="section">
        <div className="section-header">
          <h2 className="section-title">Our Premium Services</h2>
          <p className="section-desc">Choose from our wide range of professional grooming services tailored to make you look and feel your best.</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <img src={service.image} alt={service.title} className="card-image" />
              <div className="card-content">
                <h3 className="card-title">{service.title}</h3>
                <ol className="service-list">
                  {service.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ol>
                <div className="card-actions">
                  <a href="tel:+254720333127" className="btn btn-call">
                    <Phone size={16} /> Request Call
                  </a>
                  <a
                    href={'https://wa.me/+254795906060?text=Hi, I\'d like to order ' + service.title}
                    className="btn btn-whatsapp"
                  >
                    <MessageCircle size={16} /> Order Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section id="faq" className="info-section">
        <div className="section-header">
          <h2 className="section-title">FAQs & Client Stories</h2>
          <p className="section-desc">Everything you need to know and what our clients say.</p>
        </div>
        
        <div className="split-layout">
          <div className="faq-side">
            <div className="subsection-header">
              <h2 className="subsection-title">Common Questions</h2>
              <p className="subsection-desc">Got questions? We have answers</p>
            </div>
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  {faq.q}
                  <ChevronDown
                    size={20}
                    style={{ transform: openFaq === index ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.3s' }}
                    color="#F9A826"
                  />
                </button>
                {openFaq === index && (
                  <div className="faq-answer">{faq.a}</div>
                )}
              </div>
            ))}
          </div>

          <div className="testimonial-side">
            <div className="subsection-header">
              <h2 className="subsection-title">Happy Customers</h2>
              <p className="subsection-desc">Don't just take our word for it</p>
            </div>
            {testimonials.map((t, index) => (
              <div key={index} className="testimonial-card">
                <p className="testimonial-text">"{t.text}"</p>
                <div className="testimonial-footer">
                  <span className="client-name">— {t.name}</span>
                  <div className="rating">
                    {[...Array(t.rating)].map((_, i) => <Star key={i} size={16} fill="#F9A826" />)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
     
    </div>
  );
};

export default Barbershop;